<div id="matchingReport" style="margin-top:3rem;">
    <app-header title=""></app-header>
    <div class="px-5 pt-4">
        <div class="table--paybee">
            <table id ="matchingReportList" class="table" cellspacing="0" style="width: 100%;">
                <thead class="thead-light">
                <tr>
                    <th>Donor</th>
                    <th>Email</th>
                    <th>Amount</th>
                    <th>Date</th>
                    <th>Status</th>
                    <th>Reminder</th>
                    <th>Company</th>
                    <th>Actions</th>
                </tr>
                </thead>
            </table>
        </div>
    </div>
</div>